/**
 * Tiny uptime sparkline. One bar per time bucket: height encodes latency
 * (relative to the busiest bucket), colour encodes uptime in that bucket.
 * Hand-rolled SVG rather than a chart library — this renders once per tile.
 */
export default function Sparkline({ points = [], width = 96, height = 22 }) {
    if (!points.length) return null;

    const maxMs = Math.max(...points.map((p) => p.avg_ms || 0), 1);
    const gap = 1;
    const barWidth = Math.max(1, (width - gap * (points.length - 1)) / points.length);

    return (
        <svg
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            role="img"
            aria-label={`Uptime over the last ${points.length} buckets`}
            className="overflow-visible"
        >
            {points.map((p, i) => {
                const ratio = (p.avg_ms || 0) / maxMs;
                // Keep a visible stub even for near-zero latency buckets.
                const barHeight = Math.max(2, ratio * height);
                const up = p.uptime;
                const color = up == null ? "#94a3b8" : up >= 1 ? "#10b981" : up > 0 ? "#f59e0b" : "#ef4444";
                return (
                    <rect
                        key={p.t || i}
                        x={i * (barWidth + gap)}
                        y={height - barHeight}
                        width={barWidth}
                        height={barHeight}
                        rx={Math.min(1, barWidth / 2)}
                        fill={color}
                        opacity={up === 1 ? 0.55 : 0.9}
                    />
                );
            })}
        </svg>
    );
}
